module.exports = __webpack_public_path__ + "media/כיס.e54f606d.mp3";